import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { govCertapplyActions } from '../../../../store/actions'
import { alertActions } from '../../../../store/actions'

import PrivacyPopup from './PrivacyPopup'
import history from '../../../../route/history'
import { valid } from '../../../../hook/valid'

const GovEDocApplyBusiness = (props) => {
  // 사용자 신청 데이터
  const [userInfo, setUserInfo] = useState({
    memberName: '', //신청인
    ecdwAdres: 'ecdwAdres',
    applyID: '22', // 사업자등록증명신청발급서: "22"
    docKndCode: '30000100020', // 문서종류코드
    docKndNm: '사업자등록증명', // 문서종류명
    num1: '', // 앞번호 * 3자리 숫자
    num2: '', // 중간번호 * 2자리 숫자
    num3: '', // 뒷번호 *5자리 숫자
    useCode: '01', // 사용용도코드
    useName: '입찰,계약용', // 사용용도명
    privacyYn: 'N', // 납세자 - 주민번호 공개여부 *(Y - 공개,  N - 비공개)
    submitTo: '', // 제출처, 길이: 20 제한 - 한글(숫자,영문 등)
  })

  const [state, setState] = useState({
    isAgree: false, // 약관 동의 체크
    isPopup: false, // 개인정보 동의 팝업 오픈 여부
  })

  useEffect(() => {
    // 초기 작업
  }, [])

  useEffect(() => {
    if (props.user?.memberName != undefined) {
      setUserInfo({
        ...userInfo,
        memberName: props.user?.memberName,
      })
    }
  }, [props.user?.memberName])

  useEffect(() => {
    if (props.ECDApplyQFVerifyResult != null) {
      if (props.ECDApplyQFVerifyResult.rspnsCode === '100' && props.ECDApplyResult === null) {
        props.ECDApply(userInfo)
      } else if (props.ECDApplyQFVerifyResult.rspnsCode !== '100') {
        return props.error({ message: props.ECDApplyQFVerifyResult.rspnsMssage })
      }
    }
  }, [props.ECDApplyQFVerifyResult])

  useEffect(() => {
    if (props.ECDApplyResult != null) {
      if (props.ECDApplyResult.rspnsCode === '100') {
        props.success({
          message: '신청이 완료 되었습니다.',
          params: {
            type: 'SUCCESS',
            callback: () => {
              history.goBack()
            },
          },
        })
      } else if (props.ECDApplyResult.rspnsCode !== '100') {
        return props.error({ message: props.ECDApplyResult.rspnsMssage })
      }
    }
  }, [props.ECDApplyResult])

  function submitHandler() {
    /*****************************************************************************************************************
     * 필수값 체크
     *****************************************************************************************************************/
    // 이름 필수값 체크
    if (!userInfo.memberName?.trim()) {
      return props.error({ message: '이름을 입력 해주세요.' })
    }
    if (!userInfo.num1 || !userInfo.num2 || !userInfo.num3) {
      return props.error({ message: '사업자 번호를 입력 해주세요.' })
    }
    if (!userInfo.submitTo?.trim()) {
      return props.error({ message: '제출처를 입력 해주세요.' })
    }
    // 약관 동의 필수값 체크
    if (!state.isAgree) {
      return props.error({ message: '개인정보 제공 동의에 체크하셔야 합니다.' })
    }
    /*****************************************************************************************************************
     * 유효성 검사
     *****************************************************************************************************************/
    // 앞번호 3자리 숫자
    // 중간번호 2자리 숫자
    // 뒷번호 5자리 숫자
    let bizNo = userInfo.num1 + userInfo.num2 + userInfo.num3
    console.log('사업자 번호', bizNo)
    if (!valid.checkbizNo(bizNo)) {
      return props.error({ message: '정상적인 사업자 번호가 아닙니다.' })
    }

    props.ECDApplyQFVerify(userInfo)
  }

  const radioHandler = (e) => {
    const { id } = e.target
    setUserInfo((preState) => ({
      ...preState,
      privacyYn: id === 'yes' ? 'Y' : 'N',
    }))
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setUserInfo({
      ...userInfo,
      [name]: value,
    })

    let text = ''
    if (name === 'useCode') {
      text = document.getElementById('useCode').options[document.getElementById('useCode').selectedIndex].text
      setUserInfo({
        ...userInfo,
        useName: text,
      })
    }
  }
  /**
   * 개인정보 동의 체크박스
   */
  function checkHandler(e) {
    const value = e.target.checked
    setState({ ...state, isAgree: value })
  }

  return (
    <>
      <div id="contents">
        <div className="content-header">
          <a
            href="#"
            className="page-prev"
            onClick={(e) => {
              e.preventDefault()
              window.history.back()
            }}
          >
            뒤로이동
          </a>
          {/* mobile */}
          <h2>사업자등록증명</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>증명서 신청</span>
            <span>증명서 신청</span>
            <em>사업자등록증명</em>
          </div>
        </div>
        <div className="certificate-mobile">
          <h3 className="h3-tit first">신청인</h3>
          <p className="required">* 표시는 필수 입력사항입니다.</p>
          <table className="tbl-write">
            <caption>성명 항목으로 구성</caption>
            <colgroup>
              <col className="col1" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  <em className="required" /> 성명
                </th>
                <td>
                  <input
                    type="text"
                    defaultValue={userInfo.memberName}
                    className="form-keyword"
                    name="memberName"
                    onChange={handleChange}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <h3 className="h3-tit">납세자</h3>
          <p className="required">* 표시는 필수 입력사항입니다.</p>
          <table className="tbl-write">
            <caption>사업자번호, 주민번호 뒷자리 항목으로 구성</caption>
            <colgroup>
              <col className="col1" />
              <col />
            </colgroup>
            <tbody>
              {/*
               * 01 - 개인, 02 - 법인
               * - 전자증명서에서는 개인만 발급가능
               */}
              {/* <tr>
                <th scope="row">
                  <em className="required" /> 사업자구분
                </th>
                <td>
                  <input type="text" defaultValue="01" className="form-keyword" readOnly />
                </td>
              </tr> */}
              <tr>
                <th scope="row">
                  <em className="required" /> 사업자번호
                </th>
                <td>
                  <div className="input-group">
                    <input name="num1" type="text" onChange={handleChange} />
                    <span className="split">-</span>
                    <input name="num2" type="text" onChange={handleChange} />
                    <span className="split">-</span>
                    <input name="num3" type="text" onChange={handleChange} />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 주민번호 뒷자리
                </th>
                <td>
                  <span className="radio-group">
                    <input type="radio" id="yes" name="radio" defaultChecked={userInfo.privacyYn === 'Y'} onChange={radioHandler} />
                    <em />
                    <label htmlFor="yes">공개</label>
                    <input type="radio" id="no" name="radio" defaultChecked={userInfo.privacyYn === 'N'} onChange={radioHandler} />
                    <em />
                    <label htmlFor="no">비공개</label>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <h4 className="h4-tit">신청내용</h4>
          <p className="required">* 표시는 필수 입력사항입니다.</p>
          <table className="tbl-write">
            <caption>제출처, 사용 용도 항목으로 구성</caption>
            <colgroup>
              <col className="col1" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  <em className="required" /> 제출처
                </th>
                <td>
                  <input name="submitTo" type="text" className="form-keyword" onChange={handleChange} />
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <em className="required" /> 사용 용도
                </th>
                <td>
                  <select className="form-category" name="useCode" id="useCode" onChange={handleChange}>
                    <option value={'01'}>입찰,계약용</option>
                    <option value={'02'}>수금용</option>
                    <option value={'03'}>관공서제출용</option>
                    <option value={'04'}>대출용</option>
                    <option value={'05'}>여권또는비자신청용</option>
                    <option value={'06'}>국민건강보험공단제출용</option>
                    <option value={'07'}>금융기관제출용</option>
                    <option value={'08'}>신용카드발급용</option>
                    <option value={'1210000A009'}>기타</option>
                    <option value={'ZZ'}>해당없음</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
          <h4 className="h4-tit">약관 동의</h4>
          <div className="check-box">
            <input type="checkbox" id="agree" onChange={(e) => checkHandler(e)} />
            <em />
            <label htmlFor="agree" onClick={() => setState({ ...state, isPopup: !state.isPopup })}>
              개인정보 제 3자 제공 동의
            </label>
          </div>
          <div className="btn-block center">
            <a href="#" className="btn-primary lg w200" onClick={submitHandler}>
              신청하기
            </a>
          </div>
        </div>
      </div>

      {state.isPopup && <PrivacyPopup onClose={() => setState({ ...state, isPopup: false })} />}
      {/* <Alert /> */}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.userinfo.data,
    ECDApplyQFVerifyResult: state.govcertapply.ECDApplyQFVerifyResult,
    ECDApplyResult: state.govcertapply.ECDApplyResult,
    isLoading: state.govcertapply.isLoading,
    isFailure: state.govcertapply.isFailure,
  }
}

const actionCreators = {
  ECDApplyQFVerify: govCertapplyActions.ECDApplyQFVerify,
  ECDApply: govCertapplyActions.ECDApply,
  error: alertActions.error,
  success: alertActions.success,
}

export default connect(mapStateToProps, actionCreators)(GovEDocApplyBusiness)
